module.exports = __webpack_public_path__ + "img/icone-produto.341610b9.svg";